import styles from "./style.module.scss";
import { Text } from "../../components/Text";
import { useState, useRef, useEffect } from "react";
import PaymentGateway from "../../components/PaymentGateway";
import { ReactComponent as Wallet } from "../../assets/svgIcons/wallet.svg";
import { Toast } from "primereact/toast";
import { useSelector, useDispatch } from "react-redux";
import { Skeleton } from "primereact/skeleton";
import DashboardCard from "../../components/Cards/DashboardCards";
import axiosInstance from "../../api/axios.instance";
import { getDate } from "../../utils/datemaker";
import { dateCompiler } from "../../utils/tableUtils";
import { ReactComponent as GreenTickIcon } from "../../assets/svgIcons/greentick.svg";
import { ReactComponent as DownarrowIcon } from "../../assets/downarrow.svg";
import { ReactComponent as DowngraphIcon } from "../../assets/downgraphgrey.svg";
import { ReactComponent as DowngraphRIcon } from "../../assets/downgraph.svg";
import { ReactComponent as UpgraphIcon } from "../../assets/upgraph.svg";
import {
  getCountAgent,
  getCountCampaign,
  getCountEnquiry,
  getCountOrder,
  getCountTickets,
} from "../../reducers/analyticSlice";
import { useLayout } from "../../context/LayoutContext";
import modulesName from "../../roles/modulesName";
import permissions from "../../roles/permissions";
import { ReactComponent as enquiry } from "../../assets/dashboardIcons/enquiry.svg";
import { ReactComponent as campaign } from "../../assets/dashboardIcons/campaign.svg";
import { ReactComponent as ticket } from "../../assets/dashboardIcons/ticket.svg";
import { ReactComponent as orders } from "../../assets/dashboardIcons/orders.svg";
import { ReactComponent as agent } from "../../assets/dashboardIcons/agent.svg";

function SectionSelection({ analyticSection, setAnalyticSection }) {
  const dispatch = useDispatch();
  const { setLoading } = useLayout(null);
  const {
    overAllCount,
    analyticalDetails,
    skeletonloading,
    loading,
    dateRange,
  } = useSelector((state) => state.analytic);
  const { accesskey } = useSelector((state) => state.authenticate);

  const loderSkaleton = () => {
    return (
      <Skeleton
        width={"5rem"}
        height={"3rem"}
        borderRadius={"4px"}
        className="mb-2"
      />
    );
  };

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    dispatch(getCountOrder({ dateRange }));
    dispatch(getCountEnquiry({ dateRange }));
    dispatch(getCountCampaign({ dateRange }));
    dispatch(getCountAgent({ dateRange }));
    dispatch(getCountTickets({ dateRange }));
  }, [dateRange]);
  const countsmap = [
    {
      name: "Enquiries",
      sideLine: true,
      value: `${analyticalDetails?.enquiry?.statistics?.allEnquiriesCount | 0}`,
      lineclass: ``,
      skeleton: skeletonloading?.enquiry,
      show: accesskey[modulesName.ENQUIRES]?.includes(permissions.READ),
      growthdetails: analyticalDetails?.enquiry?.percentageIncrease,
      icon: enquiry,
    },
    {
      name: "Campaigns",
      sideLine: true,
      value: `${
        analyticalDetails?.campaign?.statistics?.allCampaignsCount | 0
      }`,
      lineclass: ``,
      skeleton: skeletonloading?.campaign,
      show: accesskey[modulesName.CAMPAIGN]?.includes(permissions.READ),
      growthdetails: analyticalDetails?.campaign?.percentageIncrease,
      icon: campaign,
    },
    {
      name: "Agents",
      sideLine: true,
      value: `${analyticalDetails?.agent?.statistics?.allAgentsCount | 0}`,
      lineclass: ``,
      skeleton: skeletonloading?.agent,
      show: accesskey[modulesName.AGENT]?.includes(permissions.READ),
      growthdetails: analyticalDetails?.agent?.percentageIncrease,
      icon: agent,
    },
    {
      name: "Tickets",
      sideLine: true,
      value: `${analyticalDetails?.ticket?.statistics?.allTicketsCount | 0}`,
      lineclass: ``,
      skeleton: skeletonloading?.ticket,
      show: accesskey[modulesName.TICKET]?.includes(permissions.READ),
      growthdetails: analyticalDetails?.ticket?.percentageIncrease,
      icon: ticket,
    },
    {
      name: "Orders",
      sideLine: true,
      value: `${analyticalDetails?.order?.statistics?.allOrderCount | 0}`,
      secondvalue: `₹${
        analyticalDetails?.order?.statistics?.totalOrderAmount | 0
      }`,
      lineclass: ``,
      skeleton: skeletonloading?.order,
      show: accesskey[modulesName.ORDER]?.includes(permissions.READ),
      growthdetails: analyticalDetails?.order?.percentageIncrease,
      icon: orders,
    },
  ];
  return (
    <div
      className={`w-full cp-10 flex flex-column align-items-start ${styles["record-wrap-stat"]}`}
    >
      <div
        className={`${styles["record-wrap-stat"]} flex flex-row   gap-3 justify-content-start overflow-x-auto overflow-y-hidden  w-full`}
      >
        {countsmap
          ?.filter((x) => x.show)
          ?.map((x, index) => (
            <div
              key={index}
              className="flex flex-column justify-content-center cursor-pointer lg:w-3"
            >
              <div
                className={`${
                  styles["sectiontile"]
                } flex flex-column justify-content-between rounded-2xl px-3 py-3 transition-all duration-300 ${
                  analyticSection === x.name ? styles["selected_tile"] : ""
                }`}
                onClick={() => setAnalyticSection(x.name)}
              >
                <div className="flex flex-row justify-content-between align-items-center">
                  <div className="flex align-items-center">
                    {x.icon ? (
                      <div className="flex items-center justify-center rounded-full">
                        <x.icon />
                      </div>
                    ) : (
                      <div className="rounded-full"></div>
                    )}
                  </div>
                  {x?.skeleton ? (
                    <Skeleton width="3rem" />
                  ) : (
                    <div className="flex flex-row align-items-center gap-1">
                      {dateRange?.type !== "all" ? (
                        <span>
                          {x?.growthdetails > 0 ? (
                            <UpgraphIcon />
                          ) : x?.growthdetails === 0 ? (
                            <DowngraphIcon />
                          ) : (
                            <DowngraphRIcon />
                          )}
                        </span>
                      ) : (
                        <span>&nbsp;&nbsp;</span>
                      )}
                      {dateRange?.type !== "all" && (
                        <span
                          style={{
                            color:
                              x?.growthdetails === 0
                                ? "#C1C1C1"
                                : x?.growthdetails > 0
                                ? "#00AB72"
                                : "#E61E50",
                            fontWeight: 500,
                            fontSize: "13px",
                          }}
                        >
                          {x?.growthdetails
                            ? `${Math.round(x?.growthdetails)}%`
                            : "0%"}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="flex flex-row justify-content-between align-items-center mt-2">
                  {x?.skeleton ? (
                    <Skeleton width="5rem" />
                  ) : (
                    <div className="text-sm font-medium">
                      {x.name}
                      {x?.secondvalue && (
                        <>
                          &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                          <span className="font-bold">{x.secondvalue}</span>
                        </>
                      )}
                    </div>
                  )}
                  {x?.skeleton ? (
                    <Skeleton width="5rem" />
                  ) : (
                    <div className="font-semibold text-lg">{x.value}</div>
                  )}
                </div>
              </div>
              <div
                className={`w-12 flex justify-content-center pt-1 transition-opacity duration-300 ${
                  analyticSection === x.name ? "" : "opacity-0"
                }`}
              >
                <DownarrowIcon style={{ color: "#E61E50" }} />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
export default SectionSelection;
